export const STORAGE_KEYS = {
  GAME_ACTIVE: "game",
  GAME_NAME: "gameName",
  START_TIME: "startTime",
  END_TIME: "endTime",
  QUEST_STATE: "state",
  QUEST_ORDER: "order",
  HINTS_LEFT: "hintsLeft",
};
